import List from '../views/tours/list'

export default [
    {
        path: '/admin/domain/:domain_id/tours',
        name: 'tours',
        component: List,
    }
]
